export const FORM_FIELD_KEYS = {
    NAME: 'name',
    TYPE: 'type',
    TITLE: 'title',
    REQUIRED: 'required',
    NULLABLE: 'nullable',
    MIN_LENGTH: 'minLength',
    MAX_LENGTH: 'maxLength',
    MINIMUM: 'minimum',
    MAXIMUM: 'maximum',
    ENUM: 'enum',
    FORMAT: 'format',
    PATTERN: 'pattern',
};

export const READ_ONLY_FIELD_NAMES = [
    'id',
];

export const READ_ONLY_ATTRIBUTES = [
    `id.${FORM_FIELD_KEYS.REQUIRED}`
];

enum StringFormat {
    Email = 'email',
    Uuid = 'uuid',
    Phone = 'phone',
}

export const ATTRIBUTE_OPTIONS = {
    [FORM_FIELD_KEYS.FORMAT]: Object.values(StringFormat),
};

export const ATTRIBUTE_TYPES = {
    [FORM_FIELD_KEYS.REQUIRED]: 'boolean',
    [FORM_FIELD_KEYS.NULLABLE]: 'boolean',
    [FORM_FIELD_KEYS.MIN_LENGTH]: 'number',
    [FORM_FIELD_KEYS.MAX_LENGTH]: 'number',
    [FORM_FIELD_KEYS.MINIMUM]: 'number',
    [FORM_FIELD_KEYS.MAXIMUM]: 'number',
    [FORM_FIELD_KEYS.ENUM]: 'string[]',
    [FORM_FIELD_KEYS.FORMAT]: 'string',
    [FORM_FIELD_KEYS.PATTERN]: 'string',
};

export const ATTRIBUTE_DEFAULT_VALUES = {
    [FORM_FIELD_KEYS.MIN_LENGTH]: 1,
    [FORM_FIELD_KEYS.MAX_LENGTH]: 255,
    [FORM_FIELD_KEYS.MINIMUM]: 1,
    [FORM_FIELD_KEYS.MAXIMUM]: 1,
    [FORM_FIELD_KEYS.ENUM]: [],
    [FORM_FIELD_KEYS.REQUIRED]: true,
    [FORM_FIELD_KEYS.NULLABLE]: true,
    [FORM_FIELD_KEYS.FORMAT]: '',
    [FORM_FIELD_KEYS.PATTERN]: '',
};

export const STRING_ATTRIBUTE_NAMES = [
    FORM_FIELD_KEYS.MIN_LENGTH,
    FORM_FIELD_KEYS.MAX_LENGTH,
    FORM_FIELD_KEYS.ENUM,
    FORM_FIELD_KEYS.FORMAT,
    FORM_FIELD_KEYS.PATTERN,
];

export const NUMBER_ATTRIBUTE_NAMES = [
    FORM_FIELD_KEYS.MINIMUM,
    FORM_FIELD_KEYS.MAXIMUM,
];
